import React, { useState, useEffect } from 'react';
import axios from 'axios';

function WhatsAppLinksManager({ onClose }) {
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [whatsappLinks, setWhatsappLinks] = useState({ groupLink: '', parentNumbers: [] });
  const [newParentNumber, setNewParentNumber] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchClasses();
  }, []);

  useEffect(() => {
    if (selectedClass) {
      fetchWhatsAppLinks();
    }
  }, [selectedClass]);

  const fetchClasses = async () => {
    try {
      const response = await axios.get('/api/classes');
      setClasses(response.data.map(cls => cls.name));
    } catch (error) {
      console.error('Error fetching classes:', error);
    }
  };

  const fetchWhatsAppLinks = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/whatsapp-links/${selectedClass}`);
      setWhatsappLinks(response.data);
    } catch (error) {
      console.error('Error fetching WhatsApp links:', error);
    } finally {
      setLoading(false);
    }
  };

  const addParentNumber = () => {
    if (!newParentNumber.trim()) {
      alert('Please enter a valid phone number');
      return;
    }

    if (whatsappLinks.parentNumbers.includes(newParentNumber.trim())) {
      alert('This number already exists');
      return;
    }

    setWhatsappLinks({
      ...whatsappLinks,
      parentNumbers: [...whatsappLinks.parentNumbers, newParentNumber.trim()]
    });
    setNewParentNumber('');
  };

  const removeParentNumber = (index) => {
    const updatedNumbers = whatsappLinks.parentNumbers.filter((_, i) => i !== index);
    setWhatsappLinks({
      ...whatsappLinks,
      parentNumbers: updatedNumbers
    });
  };

  const saveWhatsAppLinks = async () => {
    if (!selectedClass) {
      alert('Please select a class');
      return;
    }

    try {
      setLoading(true);
      await axios.post('/api/whatsapp-links', {
        className: selectedClass,
        groupLink: whatsappLinks.groupLink,
        parentNumbers: whatsappLinks.parentNumbers,
        createdBy: 'Admin Level 1'
      });
      alert('WhatsApp links saved successfully!');
    } catch (error) {
      console.error('Error saving WhatsApp links:', error);
      alert('Error saving WhatsApp links');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
      <div style={{ background: 'white', width: '90%', maxWidth: '600px', height: '90%', borderRadius: '15px', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.3)' }}>
        
        {/* Header */}
        <div style={{ background: 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)', color: 'white', padding: '20px', position: 'relative' }}>
          <button 
            onClick={onClose}
            style={{ position: 'absolute', right: '20px', top: '20px', background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', borderRadius: '50%', width: '40px', height: '40px', cursor: 'pointer', fontSize: '18px' }}
          >
            ✕
          </button>
          
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '32px', marginBottom: '10px' }}>📱</div>
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>WhatsApp Links Manager</h2>
            <p style={{ margin: '8px 0 0 0', fontSize: '16px', opacity: 0.9 }}>Configure WhatsApp links for each class</p>
          </div>
        </div>

        {/* Content */}
        <div style={{ flex: 1, padding: '20px', overflowY: 'auto' }}>
          
          {/* Class Selection */}
          <div style={{ background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)', padding: '20px', borderRadius: '12px', marginBottom: '20px', border: '2px solid #2196f3' }}>
            <h4 style={{ margin: '0 0 15px 0', color: '#1565c0', fontSize: '18px' }}>🎓 Select Class</h4>
            <select 
              value={selectedClass}
              onChange={(e) => setSelectedClass(e.target.value)}
              style={{ width: '100%', padding: '12px', border: '2px solid #2196f3', borderRadius: '8px', fontSize: '16px', fontWeight: 'bold' }}
            >
              <option value="">Choose a class...</option>
              {classes.map(cls => (
                <option key={cls} value={cls}>{cls}</option>
              ))}
            </select>
          </div>

          {selectedClass && (
            <>
              {/* Group Link Section */}
              <div style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '20px', borderRadius: '12px', marginBottom: '20px', border: '2px solid #25d366' }}>
                <h4 style={{ margin: '0 0 15px 0', color: '#128c7e', fontSize: '18px' }}>👥 WhatsApp Group Link</h4>
                <input 
                  type="url"
                  value={whatsappLinks.groupLink}
                  onChange={(e) => setWhatsappLinks({...whatsappLinks, groupLink: e.target.value})}
                  placeholder="https://chat.whatsapp.com/..."
                  style={{ width: '100%', padding: '12px', border: '2px solid #25d366', borderRadius: '8px', fontSize: '14px', marginBottom: '10px' }}
                />
                <small style={{ color: '#128c7e', fontSize: '12px' }}>
                  Teachers will be able to share diary to this group with one click
                </small>
              </div>

              {/* Parent Numbers Section */}
              <div style={{ background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)', padding: '20px', borderRadius: '12px', marginBottom: '20px', border: '2px solid #ff9800' }}>
                <h4 style={{ margin: '0 0 15px 0', color: '#e65100', fontSize: '18px' }}>📞 Parent Phone Numbers</h4>
                
                <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
                  <input 
                    type="tel"
                    value={newParentNumber}
                    onChange={(e) => setNewParentNumber(e.target.value)}
                    placeholder="Enter parent phone number (with country code)"
                    style={{ flex: 1, padding: '10px', border: '2px solid #ff9800', borderRadius: '8px', fontSize: '14px' }}
                  />
                  <button 
                    onClick={addParentNumber}
                    style={{ background: '#ff9800', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' }}
                  >
                    ➕ Add
                  </button>
                </div>

                <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {whatsappLinks.parentNumbers?.length > 0 ? (
                    whatsappLinks.parentNumbers.map((number, index) => (
                      <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', background: 'white', borderRadius: '8px', marginBottom: '8px', border: '1px solid #ff9800' }}>
                        <span style={{ fontWeight: 'bold', color: '#e65100' }}>📱 {number}</span>
                        <button 
                          onClick={() => removeParentNumber(index)}
                          style={{ background: '#dc3545', color: 'white', border: 'none', borderRadius: '50%', width: '30px', height: '30px', cursor: 'pointer', fontSize: '14px' }}
                          title="Remove number"
                        >
                          ✕
                        </button>
                      </div>
                    ))
                  ) : (
                    <div style={{ textAlign: 'center', color: '#e65100', padding: '20px', fontStyle: 'italic' }}>
                      No parent numbers added yet
                    </div>
                  )}
                </div>
                
                <small style={{ color: '#e65100', fontSize: '12px', display: 'block', marginTop: '10px' }}>
                  Teachers will see individual buttons for each parent number to share diary directly
                </small>
              </div>
            </>
          )}
        </div>

        {/* Footer */}
        <div style={{ background: '#f8f9fa', padding: '20px', borderTop: '2px solid #dee2e6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ color: '#6c757d', fontSize: '14px' }}>
            {selectedClass ? `Configuring WhatsApp links for Class ${selectedClass}` : 'Select a class to start configuring'}
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button 
              onClick={onClose}
              style={{ background: '#6c757d', color: 'white', border: 'none', padding: '12px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' }}
            >
              Cancel
            </button>
            {selectedClass && (
              <button 
                onClick={saveWhatsAppLinks}
                disabled={loading}
                style={{ 
                  background: loading ? '#e0e0e0' : '#25d366', 
                  color: loading ? '#666' : 'white', 
                  border: 'none', 
                  padding: '12px 20px', 
                  borderRadius: '8px', 
                  cursor: loading ? 'not-allowed' : 'pointer', 
                  fontSize: '14px', 
                  fontWeight: 'bold' 
                }}
              >
                {loading ? '💾 Saving...' : '💾 Save WhatsApp Links'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhatsAppLinksManager;